module.exports = __webpack_public_path__ + "img/fk.a8432e33.svg";